import { render, staticRenderFns } from "./DeleteOwnerCommittee.vue?vue&type=template&id=30c1c188&scoped=true"
import script from "./DeleteOwnerCommittee.vue?vue&type=script&lang=js"
export * from "./DeleteOwnerCommittee.vue?vue&type=script&lang=js"
import style0 from "./DeleteOwnerCommittee.vue?vue&type=style&index=0&id=30c1c188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1c188",
  null
  
)

export default component.exports